import { ApiLottoUploadCsvPostRequest, Configuration, LottoApi, LottoDto } from '@desio/api';
import { createAction, createAsyncThunk } from '@reduxjs/toolkit';
import { ThunkApiConfig } from 'store';
import { hideLoader, showLoader } from 'store/actions';
import getConfiguration, { errorHandler } from 'store/config';

export const setDataInizio = createAction<Date, 'campagne/setDataInizio'>('campagne/setDataInizio');
export const setDataFine = createAction<Date, 'campagne/setDataFine'>('campagne/setDataFine');

export const addLottoType = 'campagne/addLotto';

export const addLotto = createAsyncThunk<LottoDto | undefined, ApiLottoUploadCsvPostRequest, ThunkApiConfig>(
  addLottoType, async (obj, { dispatch, extra, getState }) => {
    try {

      if (extra.mock) {
        //return (await import('../../mock/get-add-lotto.json')).default;
      } else {
        dispatch(showLoader('upload-file'));
        return await new LottoApi(getConfiguration(Configuration, extra, getState)).apiLottoUploadCsvPost(obj);
      }
    } catch (error) {
      errorHandler(error, dispatch);
    } finally {
      dispatch(hideLoader('upload-file'));
    }
  }
);
export const resetLottoCaricatoAction = createAction<void, 'campagne/resetLottoCaricato'>('campagne/resetLottoCaricato');